import { ChangeDetectionStrategy,Component, inject, input, model, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
    selector: 'admin-translatable-label-field',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        RouterLink,
    ],
    templateUrl: './translatable-label-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './translatable-label-field.component.scss',
})
export class TranslatableLabelFieldComponent implements OnInit {
    private readonly dialogRef = inject(MatDialogRef<unknown>, { optional: true });
    private readonly route = inject(ActivatedRoute);

    readonly defaultCulture = 'en';
    readonly label = input<string>('');
    readonly value = model<string>('');
    readonly translations = model<Record<string, string>>({});
    readonly locales = input<string[]>([]);
    readonly storeId = input<string | undefined>(undefined);

    readonly showTranslation = signal(false);

    protected get manageLocalesLink(): any[] | null {
        const id = this.storeId() ?? this.route.snapshot.params['storeId'] ?? this.route.parent?.snapshot.params['storeId'];
        return id ? ['/stores', id, 'designer', 'custom-locales'] : null;
    }

    protected toggleTranslation() {
        this.showTranslation.update(s => !s);
    }

    protected onManageLocalesClick() {
        this.dialogRef?.close();
    }

    ngOnInit() {
        if (this.value() && !this.translations()[this.defaultCulture]) {
            this.updateLocale('en', this.value());
        }
    }

    protected updateLocale(locale: string, newValue: string) {
        this.translations.update(translations => ({
            ...translations,
            [locale]: newValue,
        }));
    }
}
